import ClientReviewCard, { ClientReviewCardProps } from './ClientReviewCard';

export default ClientReviewCard;
export type { ClientReviewCardProps };
